import { render } from "./Photo.modal.vue?vue&type=template&id=0b75a7d6"
import script from "./Photo.modal.vue?vue&type=script&lang=js"
export * from "./Photo.modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__